import { Flex, SectionMessage, SkeletonBox, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { usePayNowOAuthCallback } from '@features/paynow/hooks/usePayNowOAuthCallback'
import { usePayNowStatus } from '@features/paynow/hooks/usePayNowStatus'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { CardPaymentsEmptyState } from '../CardPaymentsEmptyState'
import { CardPaymentsSettings } from '../CardPaymentsSettings'

export const CardPaymentsContent = (): ReactElement => {
  const { t } = useTranslation()

  const { isProcessingOAuthCallback } = usePayNowOAuthCallback()
  const { hasPayNowSettings, isLoading, isError } = usePayNowStatus()
  const { organization } = useUserOrganization()

  const isFreePlan = organization?.subscriptionProductPlan?.includes('free') ?? true

  if (isLoading || isProcessingOAuthCallback) {
    return (
      <Flex flexDirection="column" gap={Spacing.S24} data-testid="card-payments-loading">
        <SkeletonBox fullWidth height={160} />
        <SkeletonBox fullWidth height={120} />
      </Flex>
    )
  }

  if (isError) {
    return <SectionMessage variant="error">{t('settings.organization.card_payments.error')}</SectionMessage>
  }

  return hasPayNowSettings ? <CardPaymentsSettings /> : <CardPaymentsEmptyState isFreePlan={isFreePlan} />
}
